export default __webpack_public_path__ + "media/images/svg/in-icon-outline-4e4f7738773b21a31cda1848a6824add.svg";